module.exports = __webpack_public_path__ + "img/mail.d4009ca0.svg";